module.exports = __webpack_public_path__ + "static/media/file-PNG.92407582.svg";